<lib-ikp-top-page
  [title]="'global.registration.thankyou.title'"
  [showGoBackLink]="false"
  [dataTest]="'accountRegistration-header-thankYouTopPageTitle'"
/>
@if (isLoading()) {
  <mwe-loading-spinner-extended />
}
@if (errorHappened() && !isLoading()) {
  <mwe-alert type="danger" titleKey="global.errors.customerRegistration.title" iconClassOverwrite="fas fa-exclamation">
    <button (click)="handleRequest()" class="underline bg-transparent text-white border-0 px-0" data-test="danke-button-retryInvitation">
      {{ 'global.errors.customerRegistration.buttonText' | translate }}
    </button>
  </mwe-alert>
}
@if (!errorHappened() && !isLoading()) {
  <mwe-basic-card>
    <div>
      <div class="row mb-4">
        <div class="col my-auto text-center">
          <img src="/assets/img/success.png" style="height: 200px" class="mt-3" alt="Daumen nach oben Erfolgsbild" />
        </div>
      </div>
      <h1 data-test="mwe-confirmation-view-header-success" class="h3 text-center">
        {{ 'global.registration.thankyou.cardTitle' | translate }}
      </h1>
      <p class="text-center mt-3">
        {{ 'global.registration.thankyou.cardText' | translate }}
      </p>
    </div>
  </mwe-basic-card>
}
@if (!isLoading()) {
  <div class="process-footer mt-5 mt-lg-6">
    <div class="buttons py-0" role="navigation">
      <mwe-button
        [buttonId]="'mwe-button-primary'"
        [labelKey]="'global.registration.thankyou.createAccount'"
        [disabled]="false"
        [showSpinner]="false"
        (click)="navigateToRegisterAccount()"
        class="btn-container d-block back"
      />
      <mwe-button
        [buttonId]="'mwe-button-secondary'"
        [labelKey]="'global.registration.thankyou.close'"
        [disabled]="false"
        [showSpinner]="false"
        [category]="'secondary'"
        (click)="navigateToHome()"
        class="btn-container d-block back"
      />
    </div>
  </div>
}
